// FastForwardFadeInOut.js
'use strict';
import { keyframes } from 'styled-components';

// Base animation keyframes (without rotation)
const fastForwardFadeInOutBase = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  20% {
    opacity: 1;
    transform: scale(1.1);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
  80% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.5);
  }
`;

// Animation keyframes with rotation for rewind
const fastForwardFadeInOutRotated = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5) rotate(180deg);
  }
  20% {
    opacity: 1;
    transform: scale(1.1) rotate(180deg);
  }
  40% {
    opacity: 1;
    transform: scale(1) rotate(180deg);
  }
  80% {
    opacity: 1;
    transform: scale(1) rotate(180deg);
  }
  100% {
    opacity: 0;
    transform: scale(0.5) rotate(180deg);
  }
`;

// Function that returns dynamic animation based on rewind state
const fastForwardFadeInOut = ({ isRewind = false } = {}) =>
  isRewind ? fastForwardFadeInOutRotated : fastForwardFadeInOutBase;

export default fastForwardFadeInOut;
